import Button from "devextreme-react/button";
import { useContext } from "react";
import { useGetCompany } from "../../../../api/company";
import { LoadPagePanel } from "../../../../components";
import { AR, BusinessFlow, FileTypes, ROType } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useSubmitInvoice } from "../api/submit-invoice";
import { RetailOrderContext } from "../context/RetailOrderContext";

export default function SubmitFilesButton() {

	const { order, refetchOrder } = useContext(RetailOrderContext);
	const dealer = useGetCompany(order.details.dealerCompanyID);

	const cocFileTypeName =
		order.details.roTypeID === ROType.CabinetInstallOrder ? 'AOC' :
			order.details.isDeliveryOnly ? 'POD' : dealer.data?.businessFlowID == BusinessFlow.Lowes ?
				'COC' : 'AOC';

	const filesNotRequired = order.details.roTypeID === ROType.Measure && dealer.data?.businessFlowID === BusinessFlow.Lowes;

	const submitInvoice = useSubmitInvoice(
		order.details.retailOrderID,
		order.details.cfiInvoiceNumber,
		() => {
			showSuccessMessage(filesNotRequired ? "Order has been submitted" : "Files have been submitted");
			refetchOrder();
		},
		(error) => showErrorMessage(error)
	);

	return (
		<>
			<Button
				elementAttr={{ 'data-testid': 'btn-submit-files' }}
				text={filesNotRequired ? "Submit" : "Submit Files"}
				icon="Inscyth-Confirm"
				visible={order.details.activeARs.includes(AR.CfiToUploadCocInvoice)}
				disabled={submitInvoice.isLoading}
				onClick={() => {
					if (order.details.roTypeID === ROType.Plumbing && !order.details.files.find(x => !x.fromLinkedOrder)) {
						showErrorMessage('At least one file is required');
					}
					else if (order.details.roTypeID !== ROType.Measure && order.details.roTypeID !== ROType.Plumbing &&
						!order.details.files.find(x => x.fileTypeID === FileTypes.COC)) {

						if (order.details.roTypeID === ROType.CabinetInstallOrder) {
							showErrorMessage('AOC file and at least one photo are required');
						}
						else {
							showErrorMessage(cocFileTypeName + ' file is required');
						}
					}
					else if (order.details.roTypeID === ROType.CabinetInstallOrder &&
						!order.details.files.find(x => x.fileTypeID === FileTypes.DisplayPhoto)) {
						showErrorMessage('At least one photo is required');
					}
					else if (dealer.data?.businessFlowID !== BusinessFlow.Lowes &&
						order.details.roTypeID === ROType.Measure &&
						!order.details.files.find(x => x.fileTypeID === FileTypes.PostTemplateDrawing)) {
						showErrorMessage('Post Template Drawing file is required');
					}
					else {
						submitInvoice.mutate();
					}
				}} >
			</Button>
			<LoadPagePanel visible={submitInvoice.isLoading}></LoadPagePanel>
		</>
	)
}
